import odin, { Secrets } from '@philips/odin';

import Constructor from '../util/constructor';
import MetaValidator from '../util/meta-validator';

const _isController = Symbol('controller-def');
const _fragment = Symbol('fragment');
const _component = Symbol('component');

const paramsValidator = MetaValidator.create().str('fragment', true).str('component', false).validator();

interface ControllerArgs {
  fragment: string;
  component?: string;
}

function Controller(args: ControllerArgs): Function {
  return _Controller(args);
}

function _Controller(definition: Constructor|ControllerArgs, params?: ControllerArgs): Constructor {
  const validate = MetaValidator.validateDecorator(_Controller, paramsValidator, definition as Constructor, params);

  if (validate) {
    return validate;
  }

  const { fragment: domain = '', component: name = null } = params || {};
  //MetaValidator.validateDomain(params.domain, 2);

  Secrets.setCustom(definition);
  Secrets.setSingleton(definition);
  Secrets.setDiscardable(definition);

  setter(definition, _isController, true);
  setter(definition, _fragment, domain);
  setter(definition, _component, name);

  return register(definition as Constructor, domain, { name });
}

function setter(target: any, key: any, value: any): void {
  target[key] = value;
}

function register(definition: Constructor, domain: string, args: object): Constructor {
  const bundle = odin.bundle(domain);

  bundle.register(definition, args);

  return definition;
}

function isController(definition: any): boolean {
  const is = definition[_isController] === true;
  return is || definition.constructor[_isController] === true;
}

function get(definition: any): { fragment: string; component: string } {
  const target = definition.constructor;
  return {
    fragment: target[_fragment],
    component: target[_component],
  };
}

export { Controller as default, isController, get };
